import { useSyncExternalStore } from 'react';

// Meldung „es gibt eine neue Fassung" — ohne den ServiceWorker zu kennen.
//
// Die Verdrahtung mit vite-plugin-pwa steht in main.tsx. Hier liegt nur
// der Schalter, den die Oberfläche abfragt. Der Grund für die Trennung ist
// der Testlauf: `virtual:pwa-register` gibt es nur im Vite-Build, ein
// Import davon in einer Komponente würde jeden Test mitreißen, der sie
// rendert.

type Neuladen = () => void;

let neuladen: Neuladen | null = null;
const hoerer = new Set<() => void>();

function melden(): void {
  for (const h of hoerer) h();
}

/**
 * Der ServiceWorker meldet eine wartende neue Fassung.
 *
 * `wieNeuladen` löst den Wechsel aus: der wartende Worker übernimmt und
 * die Seite lädt neu.
 */
export function neueVersionGefunden(wieNeuladen: Neuladen): void {
  // Nur die erste Meldung zählt. Die Prüfung auf neue Fassungen läuft
  // periodisch und bei jedem Sichtbarwerden des Fensters; solange
  // dieselbe Fassung wartet, soll sie den Hinweis nicht immer wieder
  // neu auslösen.
  if (neuladen !== null) return;
  neuladen = wieNeuladen;
  melden();
}

/** Lädt auf die neue Fassung um. Ohne wartende Fassung wirkungslos. */
export function aufNeueVersionWechseln(): void {
  neuladen?.();
}

function abonnieren(h: () => void): () => void {
  hoerer.add(h);
  return () => {
    hoerer.delete(h);
  };
}

/** Wartet gerade eine neue Fassung? */
export function useNeueVersion(): boolean {
  return useSyncExternalStore(
    abonnieren,
    () => neuladen !== null,
    () => false
  );
}

/** Nur für Tests: Schalter zurückstellen. */
export function _zuruecksetzen(): void {
  neuladen = null;
  melden();
}
